import { render, staticRenderFns } from "./boy-icon.vue?vue&type=template&id=4b10c484"
import script from "./boy-icon.vue?vue&type=script&lang=js"
export * from "./boy-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports